import { apiFetch } from './client';

export interface CallerBookmarkRow {
  id: string;
  reseller_id: string;
  customer_id: string;
  from_number: string;
  recording_id: string;
  recording_name: string | null;
  recording_duration_ms: number | null;
  position_ms: number;
  created_at: string;
  updated_at: string;
}

export interface ListCallerBookmarksParams {
  customer_id?: string;
  search?: string;
  limit?: number;
}

export const callerBookmarks = {
  list: (params: ListCallerBookmarksParams = {}) => {
    const q = new URLSearchParams();
    if (params.customer_id) q.set('customer_id', params.customer_id);
    if (params.search) q.set('search', params.search);
    if (params.limit) q.set('limit', String(params.limit));
    const qs = q.toString();
    return apiFetch<{ rows: CallerBookmarkRow[] }>(
      `/api/caller-bookmarks${qs ? `?${qs}` : ''}`,
    );
  },

  remove: (id: string) =>
    apiFetch(`/api/caller-bookmarks/${id}`, { method: 'DELETE' }),
};
